export default "__VITE_ASSET__ad267ba8__"